import updateServiceWorkerCache from 'serviceWorkers/cacheUpdate';
import {MatchPairList, PairsParams} from './types';

export const updateMatchResponsesCache = (params: PairsParams) =>
  updateServiceWorkerCache<MatchPairList>({
    cacheName: 'letrusAPI-questionnaireAnswers', // service worker cache group name
    endpoint: `${process.env.REACT_APP_API_URL}/api/v1/question_attempts/matching_responses/?question_id=${params.question_id}&step_id=${params.step_id}&lpui_id=${params.lpui_id}
`, // cached endpoint url
  });

// utilitary functions
export const cachedMatchResponses = {
  update: (params: PairsParams, responses: MatchPairList['responses']) => {
    const cachedInstance = updateMatchResponsesCache(params);
    return cachedInstance((cachedQuestionAttempt) => ({
      ...cachedQuestionAttempt,
      responses,
    }));
  },
};
